import React, { useEffect } from "react";
import { useDispatch } from "react-redux/es/exports";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
  AddOptions,
  DeleteOptions,
  EditOptions,
  EditQuestionsDescription,
  EditQuestionsTitle,
  EditSurveyRequired,
  SetSurvey,
  EditQuestionsId,
  EditQuestionsEmoji,
} from "../../redux/slice/SurveySlice/SurveySlice";

//Questions Types :S
import Checkboxes from "./QuestionsBody/Checkboxes/Checkboxes";
import Scores from "./QuestionsBody/Scores/Scores";
import ShortAnswer from "./QuestionsBody/ShortAnswer/ShortAnswer";
import SingleChoice from "./QuestionsBody/SingleChoice/SingleChoice";
import QuestionsHeader from "./QuestionsHeader/QuestionsHeader";
import BooleanChoice from "./QuestionsBody/Boolean/boolean";
export default function Questions({
  index,
  id,
  type,
  title,
  description,
  options,
  required,
  onFocus,
  onEdit = false
}) {
  const dispatch = useDispatch();
  const history = useHistory();

  //Add Questions ID
  // useEffect(() => {
  //   dispatch(EditQuestionsId({ index: index, id: id }));
  // }, []);

  //Change Questions Description
  function ChangeDescription(value) {
    dispatch(EditQuestionsDescription(value));
  }

  //Change Questions Title
  function ChangeTile(value) {
    dispatch(EditQuestionsTitle(value));
  }

  //Change Questions Emoji
  function ChangeEmoji(value) {
    dispatch(EditQuestionsEmoji(value));
  }

  /*
  ******************
    CheckBox and Single Func
  ******************
  */

  //Change Questions Options
  function ChangeOptionsOptions(value, index) {
    dispatch(EditOptions({ value: value, index: index }));
  }

  //Add Questions Options
  function AddQuestions(value) {
    setTimeout(() => {
      dispatch(AddOptions(value));
    }, 100);
  }

  //Delete Questions Options
  function DeleteQuestions(value) {
    dispatch(DeleteOptions(value));
  }

  function ChangeRequired(value) {
    console.log(value);
    dispatch(EditSurveyRequired(value));
  }

  //Error Function
  function ErrorFunction() {
    toast.error("Bir şeyler yolunda gitmedi.Lütfen yeni anket açınız.", {
      position: "bottom-center",
    });
    dispatch(
      SetSurvey({
        title: "Anket 1",
        description: "Lütfen açıklamayı buraya giriniz. (Zorunlu Değildir)",
        questions: [],
      })
    );
    history.push("/home");
  }

  function QuestionsBottomSelector(value) {
    switch (value) {
      case "multi":
        return (
          <>
            <Checkboxes
              options={options}
              ChangeOpitons={(value, index) =>
                ChangeOptionsOptions(value, index)
              }
              onFocus={onFocus}
              AddOptions={(value) => AddQuestions(value)}
              DeleteOptions={(index) => DeleteQuestions(index)}
              Error={() => ErrorFunction()}
              onEdit={onEdit}
            />
          </>
        );
      case "single":
        return (
          <>
            <SingleChoice
              options={options}
              ChangeOpitons={(value, index) =>
                ChangeOptionsOptions(value, index)
              }
              onFocus={onFocus}
              AddOptions={(value) => AddQuestions(value)}
              DeleteOptions={(index) => DeleteQuestions(index)}
              Error={() => ErrorFunction()}
              onEdit={onEdit}
            />
          </>
        );

      case "score":
        return <Scores />;
      case "input":
        return <ShortAnswer />;
      case "boolean":
        return<BooleanChoice
          options={options}
          AddOptions={(value) => AddQuestions(value)}
          ChangeOpitons={(value, index) =>
            ChangeOptionsOptions(value, index)
          }
          onChangeSmile={(value) => ChangeEmoji(value)}
           />
      default:
        break;
    }
  }

  return (
    <div className="lg:w-[1000px] md:w-[600px] h-full ">
      <QuestionsHeader
        title={title}
        description={description}
        required={required}
        onChangeDescription={(e) => ChangeDescription(e.target.value)}
        onChangeTitle={(e) => ChangeTile(e.target.value)}
        onChangeRequired={(e) => ChangeRequired(e.target.checked)}
        onFocus={onFocus}
        onEdit={onEdit}
      />
      {QuestionsBottomSelector(type)}
    </div>
  );
}
